<template>
  <v-dialog v-model="show" max-width="800">
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.PROMO_CODES') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="mb-4">
          {{ $vuetify.lang.t('$vuetify.CREATE_NEW_PROMO_CODES') }}
        </div>
        <v-row class="d-flex align-center">
          <v-col cols="4">
            <v-text-field
              v-model.number="amountOfNewCodes"
              :label="$vuetify.lang.t('$vuetify.AMOUNT_OF_NEW_CODES')"
              :placeholder="$vuetify.lang.t('$vuetify.AMOUNT_OF_NEW_CODES')"
              outlined
              hide-details
              type="number"
              class="ma-0"
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-btn color="success" @click="generateNewCodes()">
              {{ $vuetify.lang.t('$vuetify.GENERATE') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-inline">
              <span class="font-weight-bold">Total:</span>
              {{ campaign.PromoCodes.length }}
            </div>
            <div class="d-inline mx-3">
              <span class="font-weight-bold">Available:</span>
              {{ numberOfAvailablePromoCodes }}
            </div>
            <div class="d-inline">
              <span class="font-weight-bold">Registered:</span>
              {{ numberOfUsedPromoCodes }}
            </div>
          </v-col>
        </v-row>
        <v-col cols="12" sm="6" class="overflow-hidden">
          <ul class="overflow-y-auto" style="max-height: 200px;">
            <li
              v-for="code in currentPromoCodes"
              :key="code.Id"
              :class="{ 'line-through': code.UsedByClientID > 0 }"
            >
              {{ code.Code }}
            </li>
          </ul>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PromoCodesDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      amountOfNewCodes: 0,
      currentPromoCodes: [],
      numberOfUsedPromoCodes: 0,
      numberOfAvailablePromoCodes: 0
    }
  },
  computed: {
    ...mapGetters('campaigns', ['campaign']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.amountOfNewCodes = 0
          this.$emit('close')
        }
      }
    }
  },
  created() {
    this.currentPromoCodes = this.campaign.PromoCodes
    this.calculateAvailableAndUsedPromoCodes()
  },
  methods: {
    ...mapActions('campaigns', ['generateCodes']),
    calculateAvailableAndUsedPromoCodes() {
      if (Array.isArray(this.campaign.PromoCodes)) {
        for (let i = 0; i < this.campaign.PromoCodes.length; i += 1) {
          if (this.campaign.PromoCodes[i].UsedByClientID > 0) {
            this.numberOfUsedPromoCodes += 1
          } else {
            this.numberOfAvailablePromoCodes += 1
          }
        }
      }
    },
    async generateNewCodes() {
      const newPromoCodes = await this.generateCodes({
        amountOfNewCodes: this.amountOfNewCodes,
        campaignId: this.campaign.ID
      })
      newPromoCodes.forEach(code => {
        this.$store.commit('campaigns/addCampaignPromoCode', code)
      })
      this.calculateAvailableAndUsedPromoCodes()
    }
  }
}
</script>

<style scoped>
.line-through {
  text-decoration: line-through;
}
</style>
